var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border border-solid border-grey-200 bg-white shadow sm:rounded-lg"},[_c('div',[_vm._t("header")],2),_c('div',[_vm._t("content")],2),_c('div',[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }